import { gql } from '@apollo/client';

export const GET_RINK_INFO = gql`
  query ($rinkId: Int) {
    rinks(where: { id: { _eq: $rinkId } }) {
      address
      city
      mapString
      name
      id
      website
    }
  }
`;
